export enum EFontStyle {
  green = 'GREEN',
  bold = 'BOLD'
}
